export { default } from './PasswordSecurity.data';
